export default {
    Normal: 'productIconImage1',
    Alarm: 'productIconImage2',
    Lose: 'productIconImage3',
    Offline: 'productIconImage4',
    NotActive: 'productIconImage5'
}